<template>
    <div>
        <div v-if="atendimento && atendimento.marcacao && atendimento.marcacao.estoque_solicitacoes && atendimento.marcacao.estoque_solicitacoes.length">
            <div class="small mt-3" v-if="!notitle">
                <span class="badge badge-secondary mr-2">{{ atendimento.marcacao.estoque_solicitacoes.length }}</span>
                <a href="#" @click.prevent="exibir_solics = !exibir_solics" class="card-link">{{ $route.meta.vacina ? 'Solicitação de Consumo da Vacina' : 'Solicitações de Mat/Med' }}</a>
            </div>

            <div class="form-row" v-if="exibir_solics || notitle">
                <div class="col col-12 col-md-6">
                    <ul class="list-group">
                        <li class="list-group-item d-flex justify-content-between" v-for="(solic, isx) in atendimento.marcacao.estoque_solicitacoes" :key="isx">
                            <div>
                                <div>
                                    #{{ solic.id_estoque_solicitacao }}
                                    <span class="small text-muted ml-2" v-if="solic.local" title="Local de Armazenagem">{{ solic.local.st_estoque_local }}</span>

                                    <span v-if="solic.centro_custo" class="small text-muted ml-2" title="Centro de Custo">
                                        <i class="fa fa-caret-right mr-2" aria-hidden="true"></i>
                                        {{ solic.centro_custo.search }}
                                    </span>

                                    <span v-if="solic.dt_aplic && solic.hr_aplic" class="small text-muted ml-2" title="Data e Hora de Aplicação">
                                        <i class="fa fa-caret-right mr-2" aria-hidden="true"></i>
                                        {{ $util.getFormatDate(solic.dt_aplic) }} {{ solic.hr_aplic }}
                                    </span>

                                    <span class="badge badge-danger ml-2" v-if="solic.fl_estorno">
                                        <i class="fas fa-undo-alt mr-1"></i>
                                        Devolução
                                    </span>
                                </div>
                                <div v-for="(esi, iex) in solic.items" :key="iex">
                                    <i class="fa-solid fa-circle-exclamation text-warning fa-fw mr-2" v-if="esi.links && esi.links.length && !esi.links.find(link => link.movimentacao.in_quantidade)"></i>
                                    <i class="fa-solid fa-circle text-secondary fa-fw mr-2" v-else-if="!esi.links || !esi.links.length"></i>
                                    <i class="fa-solid fa-circle-check text-success fa-fw mr-2" v-else></i>

                                    <span v-if="id_estoque_item_selec && ( esi.item.id_estoque_item == id_estoque_item_selec)" class="badge badge-primary">
                                        {{ esi.item.search }}    
                                    </span>
                                    <span v-else>
                                        {{ esi.item.search }}
                                    </span>
                                    
                                    <ul v-if="esi.links && esi.links.length">
                                        <li v-for="(link, ilx) in esi.links" :key="ilx" class="small">
                                            {{ link.movimentacao.in_quantidade}}/{{ esi.in_quantidade }}
                                            <span v-if="link.movimentacao.st_lote" class="ml-3">
                                                Lote: {{ link.movimentacao.st_lote }}
                                            </span>
                                            <span>
                                                <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                                                {{ $util.getFormatDate(link.movimentacao.dt_movimentacao) }}
                                                {{ link.movimentacao.dt_movimentacao.slice(11,16) }}
                                            </span>
                                            <span v-if="link.movimentacao.st_observacao" class="text-muted">
                                                <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                                                {{ link.movimentacao.st_observacao }}
                                            </span>
                                        </li>
                                    </ul>

                                </div>
                                
                            </div>
                            <div v-if="!notitle && $route.meta.vacina && atendimento.dt_inicio && atendimento.dt_inicio.slice(0,10) <= $util.hoje()">
                                <button type="button" class="btn btn-sm btn-outline-danger ml-1" v-if="solic.atendido && solic.items.find(item => item.links.find(link => link.movimentacao.in_quantidade))" @click="cancelar_atendimento_solicitacao_estoque(solic)">
                                    Cancelar Atendimento
                                </button>

                                <button type="button" class="btn btn-primary" v-else-if="!solic.atendido" @click="atender_solicitacao_estoque(solic)">
                                    Atender
                                </button>

                                <button type="button" class="btn btn-success" v-else-if="!isx" @click="regerar_solic_vacina()">
                                    Re-Solicitar
                                </button>
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="col col-12 col-md-6">
                    <table class="table table-sm table-hover">
                        <thead>
                            <tr>
                                <th>Descrição</th>
                                <th class="text-right">Qtde</th>
                                <template v-if="atendimento.consumo_kit">
                                    <th class="text-right">Kit</th>    
                                    <th class="text-right">Total</th>    
                                </template>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item_estoque, iix) in lista_matmed_consolidada(atendimento)" :key="iix" :class="id_estoque_item_selec == item_estoque.id_estoque_item ? 'table-primary' : ''">
                                <td>
                                    <a href="#" @click.prevent="id_estoque_item_selec = ( id_estoque_item_selec == item_estoque.id_estoque_item ? null : item_estoque.id_estoque_item )" class="card-link">
                                        {{ item_estoque.st_estoque_item }}
                                    </a>
                                </td>
                                <td class="text-right">{{ item_estoque.qtde }}</td>
                                <template v-if="atendimento.consumo_kit">
                                    <td class="text-right">{{ totalizar_kit(item_estoque.id_estoque_item) }}</td>    
                                    <td class="text-right">{{ item_estoque.qtde + totalizar_kit(item_estoque.id_estoque_item) }}</td>    
                                </template>
                            </tr>
                        </tbody>
                    </table>

                    <table class="table table-sm table-hover mt-3" v-if="atendimento.kits && atendimento.kits.length">
                        <thead>
                            <tr>
                                <th>Kit</th>
                                <th></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(kit, ikt) in atendimento.kits" :key="ikt">
                                <td>{{ kit.item.st_estoque_item }}</td>
                                <td>{{ kit.st_lote }}</td>
                                <td class="text-right">
                                    <a href="#" class="card-link" @click.prevent="ver_composicao(kit)">
                                        <i class="fas fa-box-open"></i>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>

        <composicao-transformacao ref="comp" />
    </div>
</template>

<script>
import _ from 'lodash';
import ComposicaoTransformacao from '../suprimentos/ComposicaoTransformacao.vue';

export default {
    data() {
        return { 
            exibir_solics: false,
            id_estoque_item_selec: null, 
        }
    },

    components: { 
        ComposicaoTransformacao,
    },

    props: ['notitle', 'atendimento'], 

    methods: { 
        ver_composicao (mov) { 
            this.$refs.comp.abrir(mov);
        },

        totalizar_kit(id_estoque_item) { 
            let kits = this.atendimento.consumo_kit ? _.get(this.atendimento.consumo_kit, id_estoque_item) : null;

            if ( !kits ) { 
                return 0;
            }

            return _.sumBy(Object.values(kits), 'in_quantidade');
        },

        cancelar_atendimento_solicitacao_estoque (solic) { 
            this.$emit('cancelar_atendimento_solicitacao_estoque', solic);
        },

        atender_solicitacao_estoque (solic) { 
            this.$emit('atender_solicitacao_estoque', solic);
        },

        regerar_solic_vacina () { 
            this.$emit('regerar_solic_vacina');
        }, 

        lista_matmed_consolidada (atendimento) { 
            if ( !atendimento || !atendimento.marcacao || !atendimento.marcacao.estoque_solicitacoes ) { 
                return [];
            }

            let lista = atendimento.marcacao.estoque_solicitacoes.flatMap(solic => { 
                return solic.items.map(function (item) { 
                    return { 
                        id_estoque_item: item.id_estoque_item, 
                        st_estoque_item: item.item.st_estoque_item, 
                        qtde: item.links.reduce((acc, link) => acc + ( link.movimentacao.in_quantidade * link.movimentacao.in_fator_saldo * -1 ), 0), 
                    };
                });     
            });

            lista = _.orderBy(
                _.map(
                    _.groupBy(lista, 'id_estoque_item'), 
                    (itens) => { 
                        return { 
                            ...itens[0], 
                            qtde: _.sumBy(itens, 'qtde'),
                        };
                    }
                ),
                'st_estoque_item'
            );

            return lista;
        },
    }
}
</script>
